import * as React from 'react';
import useStyles from './use_styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var TableRow = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    children,
    component: Component = 'tr',
    selected = false,
    variant = 'body'
  } = _ref;
  var styles = useStyles({
    selected,
    variant
  });
  return ___EmotionJSX(Component, {
    css: styles,
    ref: ref,
    role: Component === 'tr' ? null : 'row'
  }, children);
});
TableRow.displayName = 'TableRow';
export default TableRow;